/**
 * This module render the Login Panel, binds all triggers, validation and redirect the login to the FetchMainInfo authentication.
 */
var VRC = VRC || {};
VRC.Authentication = (function () {
	var ENTER_KEY = 13;

	/**
	 * Inititialize the login panel event handlers for login and forgotten password..
	 */
	var init = function () {

		var $dialog = $('#login_dialog');
		$dialog.modal();


		attachOnLoginBtnClick($dialog);
		attachKeyPressInPasswordInput($dialog);
		attachForgottenPassword($dialog);
		attachUsernameMethod();
	};

	var attachUsernameMethod = function () {
		if (g_master_data.master_data.vessel_list.length < 1) {
			$('<div class="form-group"><div class="input-group input-group-lg"><span class="input-group-addon"><i class="glyphicon glyphicon-user"></i></span><input name="login_username" class="form-control" type="text" id="login_username"  placeholder="Username"/></div></div>').appendTo('.username_field');
		} else {
 			$('<div class="input-group input-group-lg"><span class="input-group-addon"><i class="glyphicon glyphicon-user"></i></span><select name="login_id_selection" class="form-control" id="login_id_selection"></select></div>').appendTo('.username_field');
			SetAvailableDropdownList('vessel', $('#login_id_selection'));
		}
	};

	/**
	 * When clicking the forgotten password link
	 * @param $dialog The container
	 */
	var attachForgottenPassword = function ($dialog) {
		var $forgotPasswordBtn = $dialog.find('.login_dialog__forgot-password');
		$forgotPasswordBtn.unbind('click').click(function () {
			var msg = 'Generate new password and send it to the bridge email?';
			var onConfirm = function () {
				resetPassword();
			};

			VRC.ConfirmationModal.show({msg: msg, onConfirm: onConfirm});
		});
	};

	/**
	 * When clicking enter key in password field.
	 * @param $dialog The container
	 */
	var attachKeyPressInPasswordInput = function ($dialog) {
		var $passwordField = $dialog.find('#login_password');
		$passwordField.keypress(function (e) {
			if (e.which == ENTER_KEY) {
				e.preventDefault();
				login();
			}
		});
	};

	/**
	 * When pressing the login button
	 * @param $dialog The container
	 */
	var attachOnLoginBtnClick = function ($dialog) {
		var $loginBtn = $dialog.find('.login_dialog__submit-btn');
		$loginBtn.unbind('click').bind('click touchstart', function (e) {
			e.preventDefault();
			login();
		});
	};

	/**
	 * Finds all errors in the login dialog.
	 * @returns {*|jQuery} All alerts
	 */
	var getDomError = function () {
		return $('#login_dialog').find('.alert');
	};

	/**
	 * Display an alert message in the panel
	 * @param msg Message
	 * @param status (optional) alert-danger or other bootstrap status.
	 */
	var displayMessage = function (msg, status) {
		status = status || 'alert-danger';
		var $alert = getDomError();

		$alert.text(msg);
		$alert.removeClass('hidden');
		$alert.addClass(status);
	};

	/**
	 * Get values from inputfields, validates and tries to login.
	 * If sucess, redirect to HOME_PAGE.
	 * If not, show error message
	 */
	var login = function () {
		var l_operator = getOperator();
		var l_type = 'vessel'; //Always vessel
		var l_id = getVesselId();
		var l_password = getPassword();
		var vesselName = getVesselName();
		var l_username = getUsername();

		var l_can_log_in = false;

		if (l_operator === '' || l_type === '' || l_id === '' || l_password === '') {
			displayMessage('Password is required');
		}
		else {
			l_can_log_in = true;
		}

		if (l_can_log_in) {
			SetLoginInformation(vesselName, l_operator);
			FetchMainInfo(l_id, l_type, l_operator, l_password, l_username)
				.done(function (data) {
					LoadPage(G_PAGE.HOME_PAGE);
					VRC.PortManager.init();
					g_dataIsReady = true;
					$('#login_dialog').modal('hide');
					location.reload();
				})
				.fail(function (data) {
						var message = data.errorMsg;
						if (message.indexOf('ORA-20006: Invalid or missing') > 1) {
							displayMessage('Incorrect password');
						}
						else if (message.indexOf('User exceeded maxmimum number') > 1) {
							displayMessage('User exceeded maxmimum number of failed login attempts. Contact support to reopen the account');
						}
						else if (message.indexOf('ORA-20000: vessel-role')) {
							displayMessage('This vessel has a role in WELS Operator, Please log in there or contact your operator for assistance');
						}
						else {
							displayMessage('Something went wrong when trying to log on, please contact support.');
						}
				});
		}
	};

	var getOperator = function () {
		return $('#login_operator_selection').val();
	};

	var getVesselId = function () {

		var login_id;

		login_id = $('#login_id_selection').val();

		if (!login_id) {
			login_id = $('#login_username').val();
		}

		if (!login_id || login_id.length === 0) {
			alert('Please select a valid vessel in order to reset the password.');
		}

		return login_id;

	};

	var getVesselName = function(){
		return $("#login_id_selection option:selected").text();
	};

	var getPassword = function () {
		return $('#login_password').val();
	};

	var getUsername = function () {
		return $('#login_username').val();
	};

	var getResetPasswordUrl = function (operator, vesselId) {
		return G_ROOT_ADDRESS + '/reporting.reset_password?i=' + vesselId + "&o=" + operator;
	};

	var resetPassword = function () {
		var operator = getOperator();
		var vesselId = getVesselId();

		$.ajax({
			url: getResetPasswordUrl(operator, vesselId)
		})
			.done(function (data) {
				data = JSON.parse(data);
				displayMessage(data.message, 'alert-info')
			})
			.fail(function(data) {
				displayMessage(data.responseText);

		});

	};

	return {
		init: init
	}
})();